import React, { Component } from "react";


import { Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import queryString from "query-string";
import { getCurrentDay, getSelectedMonthAgo } from "../../../helpers/utils";
import {
  getPaymentCostInspectionReportFilters,
  getPaymentCostInspectionReportList,
  setPaymentCostInspectionDate
} from "../../../store/reporting/actions";
import InspectionReportList from "./components/InspectionReportList";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class PaymentCostInspectionReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currency: [
        { label: "USD", value: "USD" },
        { label: "RUB", value: "RUB" },
        { label: "EUR", value: "EUR" },
      ],
    };
  }

  componentDidMount() {
    const parsedSearch = queryString.parse(this.props.history.location.search);

    if (this.props.inspectionDate === null) {
      const date = {
        start_date: parsedSearch.start_date || getSelectedMonthAgo(1),
        end_date: parsedSearch.end_date || getCurrentDay(),
        currency: parsedSearch.currency || this.state.currency[0].value,
      };

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: date.start_date,
          end_date: date.end_date,
          currency: date.currency
        })
      );

      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
      this.props.setPaymentCostInspectionDate(date);
      this.props.getPaymentCostInspectionReportList(date);
    } else {
      let inspectionDate = this.props.inspectionDate;

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: inspectionDate.start_date,
          end_date: inspectionDate.end_date,
          currency: inspectionDate.currency,
        })
      );

      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
      this.props.getPaymentCostInspectionReportList(inspectionDate);
    }
    this.props.getPaymentCostInspectionReportFilters();
  }

  render() {

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Payment & Cost Inspection reports | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Payment & Cost Inspection reports"
              link="/dashboard"
            />
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <InspectionReportList
                      getPaymentCostInspectionReportList={this.props.getPaymentCostInspectionReportList}
                      data={this.props.data}
                      inspectionDate={this.props.inspectionDate}
                      setPaymentCostInspectionDate={this.props.setPaymentCostInspectionDate}
                      inspectionFilters={this.props.inspectionFilters}
                      currency={this.state.currency}
                      loading={this.props.loading}
                      history={this.props.history}
                      permissions={this.props.permissions}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PaymentCostInspectionReport.propTypes = {
  data: PropTypes.any,
  inspectionDate: PropTypes.any,
  inspectionFilters: PropTypes.any,
  loading: PropTypes.bool,
  getPaymentCostInspectionReportList: PropTypes.func,
  setPaymentCostInspectionDate: PropTypes.func,
  getPaymentCostInspectionReportFilters: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any
};

const mapStateToProps = state => ({
  data: state.Reporting.inspection_data,
  inspectionDate: state.Reporting.inspectionDate,
  inspectionFilters: state.Reporting.inspection_filters,
  offers: state.Offers.offers,
  loading: state.Reporting.loading_inspection_data,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, {
  getPaymentCostInspectionReportList,
  setPaymentCostInspectionDate,
  getPaymentCostInspectionReportFilters,
})(PaymentCostInspectionReport);
